<template>
  <v-select
    id="ad-select"
    v-model="filter.analistaId"
    item-text="nome"
    item-name="usuarioId"
    item-value="usuarioId"
    :items="users"
    label="Analista"
    placeholder="Analista"
  >
    <template slot="no-data">
      Nenhum Analista retornado
    </template>
  </v-select>
</template>

<script>
import { userAPI } from './UserAPI'

export default {
  name: 'AppAnalistasCombobox',
  props: [
    'filter'
  ],
  mounted () {
    this.loadAnalistas()
  },
  methods: {
    loadAnalistas () {
      userAPI.listConsultant()
        .then(resp => {
          this.users = resp.data
        })
        .catch(resp => {
          this.$notification.error('Erro ao obter Analistas')
        })
    }
  },
  data () {
    return {
      users: []
    }
  }
}
</script>
